export const OAUTH_TOKEN_SHOW_TABS = ['general'] as const;
export type OAuthTokenShowTab = (typeof OAUTH_TOKEN_SHOW_TABS)[number];
export const OAUTH_TOKEN_DEFAULT_TAB: OAuthTokenShowTab = 'general';

/** `issued_at` is unix seconds; the rest of the API uses ISO strings. */
export const unixToIso = (value: number | null | undefined) =>
  value ? new Date(value * 1000).toISOString() : null;
